import React, { useState } from 'react';

export default function AccountActivation({ callback, onResend, cancel }) {
  const [formData, _setFormData] = useState({ code: '' });
  const setFormData = (insert) => {
    _setFormData({ ...formData, ...insert });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginBottom: '10px',
        alignItems: 'center',
        marginTop: 15,
      }}
    >
      <h2
        style={{
          marginBottom: 30,
          marginTop: 0,
        }}
      >
        Verification
      </h2>
      <div
        style={{
          marginBottom: 30,
          textAlign: 'center',
          fontWeight: 'bold',
        }}
      >
        Please enter the verification code that was sent to your email.
      </div>
      <input
        type='text'
        placeholder='Enter Code'
        value={formData.code}
        onChange={(e) => setFormData({ code: e.target.value })}
        style={{
          width: '100%',
          marginBottom: '10px',
          padding: '10px',
          border: '1px solid #436c9a',
          borderRadius: '5px',
        }}
      />
      <div
        style={{
          height: 1,
          width: '100%',
          background: '#aaa',
          marginTop: 10,
          marginBottom: 15,
        }}
      ></div>
      <button
        onClick={onResend}
        style={{
          background: '#ed2028',
          padding: 10,
          borderRadius: 10,
          border: 'none',
          width: '50%',
          color: '#fff',
          marginBottom: '10px',
        }}
      >
        Resend Code
      </button>
      <button
        onClick={() => callback(formData)}
        style={{
          background: '#436c9a',
          padding: 10,
          borderRadius: 10,
          border: 'none',
          width: '50%',
          color: '#fff',
          marginBottom: '10px',
        }}
      >
        Complete Account
      </button>
    </div>
  );
}
